import { z } from "zod";
import {
  App,
  routes as allRoutes,
  fullEndpoints,
} from "@songtradr-sso/shared/common";
import {
  emailSchema,
  staticText as sharedText,
  verificationCodeSchema,
} from "@songtradr-sso/shared/frontend";
import { staticText } from "../../shared/statics/static-text";
import { Api } from "../../shared/utils/api.utils";

// TEXT
export const text = {
  ...staticText.emailConfirmation,
  shared: { inputs: sharedText.inputs },
};

// STYLES

// DATA
export const confirmEmailViaCode = async (
  confirmEmailRequest: string,
): Promise<boolean> => {
  await Api.request({
    method: "POST",
    url: endpoints.confirmEmail,
    data: {
      confirmEmailRequest,
    },
  });

  return true;
};

export const resendVerificationCode = async (
  email: string,
): Promise<boolean> => {
  await Api.request({
    method: "POST",
    url: endpoints.resendVerificationCode,
    data: {
      email,
    },
  });

  return true;
};

// TYPES
export type FormFields = z.infer<typeof schema>;

// CONSTANTS
export const routes = allRoutes[App.Core];
const endpoints = fullEndpoints[App.Core].auth;

export const schema = z.object({
  [text.shared.inputs.email.id]: emailSchema,
  [text.shared.inputs.verificationCode.id]: verificationCodeSchema,
});

// FUNCTIONS

// ASSETS
